<ng-container *ngIf="isLoadingDialog">
    <div class="move-dialog">
      <sync-dialog
        [config]="{
          title: title,
          subTitle: subTitle,
          isClosable: true,
          onCloseIcon: closeMoveDialog,
        }"
        [open]="open"
      >
        <div class="move-action-container">
          <sync-spinner></sync-spinner>
        </div>
      </sync-dialog>
    </div>
  </ng-container>
<div class="move-dialog" *ngIf="!initCount">
    <sync-dialog [config]="{
        title: title,
        subTitle: subTitle,
        isClosable: true,
        closeIcon: closeIconName,
        onCloseIcon: gotoSelectDir,
        actionButton: actionButton,
        cancelButton: cancelButton,
        isActionButtonDisabled:disableExecute(),
        onActionClick: onActionButtonClick,
        onCancelClick: onCancelButtonClick,
        closeButtonType: closeButtonType,
        activeButtonType: activeButtonType,
        tertiaryButtonConfig: teritaryButtonConfig,
        tertiaryButtonAlignCenter: tertiaryButtonAlignCenter,
        isButtonLoading: isProcessingJoin
      }" [open]="showMoveDialog" [onClose]="closeDialog" [hideDialogFooter]="false" [isFullScreen]="isSmallScreen"
      >
        <div
            class="move-action-container"
            [class.fixed-height]="(
               !autoMove && actionStep === moveActionStep.SELECT_DESTINATION_FOLDER || actionStep === moveActionStep.JOIN_SHARE
            )"
            [class.max-height]="actionStep === moveActionStep.TRANSFER"
            >
            <app-move-select-destination-dir
                [class.hide]="autoMove"
                *ngIf="actionStep === moveActionStep.SELECT_DESTINATION_FOLDER || actionStep === moveActionStep.JOIN_SHARE" [selectedRows]="selectedRows" [actionMoveOrCopy]="actionMoveOrCopy" (nameConflictsChange)="onNameConflictsChange($event)" [openRootFlag]="openRootFlag" [defaultTab]="defaultTab" (destinationDataChange)="handleDestinationData($event)">
            </app-move-select-destination-dir>
            <sync-spinner
                *ngIf="actionStep === moveActionStep.SELECT_DESTINATION_FOLDER && autoMove">
            </sync-spinner>

            <app-move-transfer class="move-transfer-body" *ngIf="actionStep === moveActionStep.TRANSFER" [selectedRows]="transferQueue" (transferComplete)="closeDialog()" [duplicateNameMap]="duplicateNameMap" [actionMoveOrCopy]="actionMoveOrCopy"></app-move-transfer>
            <app-move-conflicts *ngIf="actionStep === moveActionStep.ONE_CONFLICT || actionStep === moveActionStep.MANY_CONFLICT || actionStep === moveActionStep.FIX_CONFLICT" [conflictData]="conflictData"
            [actionStep]="actionStep" [conflictFileName]="conflictFileName" [conflictTotalCount]="conflictTotalCount" [(applyConflictForAll)]="applyConflictForAll" [applyFixForTotalItemCount]="applyFixForTotalItemCount"
            [actionMoveOrCopy]="actionMoveOrCopy"></app-move-conflicts>
            <app-dialog-new-folder *ngIf="actionStep === moveActionStep.NEW_FOLDER" [showDialog]="actionStep === moveActionStep.NEW_FOLDER" 
            (folderCreated)="dialogNewFolderCreated($event)" (showDialogChange)="dialogNewFolderChange($event)"
            [showFolderType]="false" [closeIconName]="'arrow-left'" [syncPid]="dirPickerService.view.cwd?.sync_id" [selectedPathListData]="selectedPathListData"></app-dialog-new-folder>
        </div>
    </sync-dialog>
</div>